export function animateCSS (element: HTMLElement, animationName: string, callback: Function): void {
  element.classList.add('animated', animationName)

  const handleAnimationEnd = () => {
    element.classList.remove('animated', animationName)
    element.removeEventListener('animationend', handleAnimationEnd)

    if (typeof callback === 'function') callback()
  }
  element.addEventListener('animationend', handleAnimationEnd)
}

export function disableForm (form: HTMLFormElement): void {
  form.querySelectorAll('button').forEach(button => button.setAttribute('disabled', ''))
}

export function enableForm (form: HTMLFormElement): void {
  form.querySelectorAll('button').forEach(button => button.removeAttribute('disabled'))
}
